import React, { useState, useEffect, useRef } from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';

import '../../styles/timer.css'; // Upewnij się, że ścieżka do CSS jest poprawna
import '../../styles/styles.css';
import aiCreatorImage from "../../images/ai-creator.png";
import filesImage from "../../images/files.jpg";
import apiFetch from "../../Api"; // Dodaj import dla ogólnych stylów

const ExamPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [exam, setExam] = useState(null);
    const [userAnswers, setUserAnswers] = useState({});
    const [message, setMessage] = useState({ type: '', text: '' });
    const [isInFullscreen, setIsInFullscreen] = useState(false);

    // --- STANY DLA TIMERA ---
    const [remainingTime, setRemainingTime] = useState(0);
    const [isTimeUp, setIsTimeUp] = useState(false);
    const timerIntervalRef = useRef(null);
    // ----------------------------

    // --- EFFECT DLA OBSŁUGI PEŁNEGO EKRANU ---
    const enterFullscreen = () => {
        if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen()
                .catch(err => {
                    console.warn(`Failed to enter fullscreen: ${err.message}`);
                    setMessage({ type: 'error-message', text: 'Nie udało się wejść w tryb pełnoekranowy. Proszę zezwolić przeglądarce na ten tryb.' });
                });
        } else {
            setMessage({ type: 'error-message', text: 'Twoja przeglądarka nie obsługuje trybu pełnoekranowego.' });
        }
    };

    useEffect(() => {
        const handleFullscreenChange = () => {
            const isCurrentlyFullscreen = !!document.fullscreenElement;
            setIsInFullscreen(isCurrentlyFullscreen);
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('mozfullscreenchange', handleFullscreenChange);
        document.addEventListener('MSFullscreenChange', handleFullscreenChange);

        setIsInFullscreen(!!document.fullscreenElement); // Sprawdź stan przy montowaniu

        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
            document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
            document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
        };
    }, []);

    // --- EFFECT DLA Wczytywania Danych Egzaminu i Timera ---
    useEffect(() => {
        if (location.state && location.state.exam) {
            setExam(location.state.exam);

            const { timeMinutes, questions } = location.state.exam;
            const calculatedQuestionNumber = questions ? questions.length : 0;
            const parsedTimeMinutes = parseInt(timeMinutes);
            const totalExamTimeSeconds = parsedTimeMinutes * calculatedQuestionNumber * 60;

            setRemainingTime(totalExamTimeSeconds);

            if (timerIntervalRef.current) {
                clearInterval(timerIntervalRef.current);
            }

            timerIntervalRef.current = setInterval(() => {
                setRemainingTime(prevTime => {
                    if (prevTime <= 1) {
                        clearInterval(timerIntervalRef.current);
                        setIsTimeUp(true);
                        return 0;
                    }
                    return prevTime - 1;
                });
            }, 1000);

        } else {
            setMessage({ type: 'error-message', text: 'Brak danych egzaminu. Proszę stworzyć nowy egzamin.' });
        }

        return () => {
            if (timerIntervalRef.current) {
                clearInterval(timerIntervalRef.current);
            }
        };
    }, [location.state]);

    // --- EFFECT DLA OBSŁUGI UPŁYWU CZASU ---
    useEffect(() => {
        if (isTimeUp) {
            setMessage({ type: 'error-message', text: 'Czas się skończył! Proszę popracować nad tempem.' });

            const redirectTimeout = setTimeout(() => {
                navigate('/my-exams');
            }, 5000);

            return () => clearTimeout(redirectTimeout);
        }
    }, [isTimeUp, navigate]);


    // --- EFFECT DLA BLOKOWANIA PRAWYCH PRZYCISKÓW MYSZY ---
    useEffect(() => {
        const handleContextMenu = (e) => {
            e.preventDefault();
        };

        document.addEventListener('contextmenu', handleContextMenu);

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
        };
    }, []);

    const handleAnswerChange = (questionIndex, answerIndex) => {
        setUserAnswers(prevAnswers => ({
            ...prevAnswers,
            [questionIndex]: answerIndex
        }));
    };

    const handleSubmitExam = async (e) => {
        e.preventDefault();

        // Dodatkowe sprawdzenie trybu pełnoekranowego przed wysłaniem
        if (!isInFullscreen) {
            setMessage({ type: 'error-message', text: 'Musisz być w trybie pełnoekranowym, aby zakończyć egzamin.' });
            return;
        }

        if (!exam) {
            setMessage({ type: 'error-message', text: 'Brak danych egzaminu do przesłania.' });
            return;
        }

        const formattedUserResponses = exam.questions.map((_, index) => ({
            questionIndex: index,
            chosenAnswerIndex: userAnswers[index] !== undefined ? userAnswers[index] : -1
        }));

        const userExamResponse = {
            examName: exam.name,
            userAnswers: formattedUserResponses
        };

        try {
            const response = await apiFetch('/api/exam/submit', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userExamResponse),
                credentials: 'include'
            });

            const data = await response.json();

            if (response.ok) {
                if (timerIntervalRef.current) {
                    clearInterval(timerIntervalRef.current);
                }
                if (document.fullscreenElement) {
                    document.exitFullscreen()
                        .catch(err => console.warn("Nie udało się wyjść z trybu pełnoekranowego:", err));
                }
                navigate('/exam/result', { state: { examResult: data } });
            } else {
                setMessage({ type: 'error-message', text: data.errorMessage || 'Nie udało się ocenić egzaminu.' });
            }
        } catch (error) {
            console.error('Błąd podczas przesyłania egzaminu:', error);
            setMessage({ type: 'error-message', text: 'Wystąpił błąd sieci lub serwera.' });
        }
    };

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

    if (!exam) {
        return (
                <div className="container home-container">
                    {message.text && (
                        <div className={`message ${message.type}`}>
                            {message.text}
                        </div>
                    )}
                    <div className="home-cards-container">
                        <Link to="/exam/create" className="home-action-card">
                            <div className="card-icon">
                                <img
                                    src={aiCreatorImage}
                                    alt="Kreator Egzaminów Próbnych"
                                    style={{ width: '150px', height: '150px' }}
                                />
                            </div>
                            <h3>Kreator Egzaminów Próbnych</h3>
                            <p>Wprowadź zasoby, na bazie których Sztuczna Inteligencja sprawdzi Twoją wiedzę</p>
                        </Link>
                    </div>
                </div>
        );
    }

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleString('pl-PL', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    };

    return (
        <div>
            <div className="container">
                {!isTimeUp && (
                    <div className="timer-display">
                        Pozostały czas: {formatTime(remainingTime)}
                    </div>
                )}
                <div className="exam-details-summary">
                    <div className="detail-item">
                        <strong>Czas na jedno pytanie:</strong> <span>{exam.timeMinutes} minut(y)</span>
                    </div>
                    <div className="detail-item">
                        <strong>Liczba pytań:</strong> <span>{exam.questions ? exam.questions.length : '0'}</span>
                    </div>
                    <div className="detail-item">
                        <strong>Rozpoczęto:</strong> <span>{formatDate(exam.startDate)}</span>
                    </div>
                    <div className="detail-item">
                        <strong>Maksymalna liczba punktów:</strong> <span>{exam.maximumScore}</span>
                    </div>
                </div>

                <div className="messages-container">
                    <h2>Pytania egzaminacyjne</h2>
                    {message.text && (
                        <div className={`message ${message.type}`}>
                            {message.text}
                        </div>
                    )}
                    <form onSubmit={handleSubmitExam}> {/* onSubmit na formularzu */}
                        {exam.questions.map((question, qIndex) => (
                            <div key={qIndex} className="question-container">
                                <p><strong>{qIndex + 1}.</strong> {question.questionMessage}</p>
                                <ul>
                                    {question.answers.map((answer, aIndex) => (
                                        <li key={aIndex}>
                                            <input
                                                type="radio"
                                                name={`question_${qIndex}`}
                                                id={`answer_${qIndex}_${aIndex}`}
                                                value={aIndex}
                                                checked={userAnswers[qIndex] === aIndex}
                                                onChange={() => handleAnswerChange(qIndex, aIndex)}
                                                required
                                                disabled={isTimeUp}
                                            />
                                            <label htmlFor={`answer_${qIndex}_${aIndex}`}>{answer.text}</label>
                                        </li>
                                    ))}
                                </ul>
                                <hr />
                            </div>
                        ))}

                        {/* Komunikat o trybie pełnoekranowym, wzorowany na ExamCreationPage */}
                        {!isInFullscreen && !isTimeUp && (
                            <div
                                className="warning-message fullscreen-prompt"
                                onClick={enterFullscreen}
                                title="Kliknij, aby przejść do trybu pełnoekranowego"
                                style={{ marginBottom: '20px' }}
                            >
                                Aby zakończyć egzamin, musisz być w trybie pełnoekranowym. Kliknij tutaj, aby przejść do pełnego ekranu.
                            </div>
                        )}

                        {/* Kontener dla przycisku Zakończ egzamin do wyśrodkowania  */}
                        <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: '20px' }}>
                            <input
                                type="submit"
                                value="Zakończ egzamin"
                                disabled={isTimeUp || !isInFullscreen}
                                className={!isInFullscreen ? 'disabled-button' : ''}
                            />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ExamPage;